import React from 'react';
import { Users } from 'lucide-react';
import { BasicInfo } from '../types';

interface Step1Props {
  basicInfo: BasicInfo;
  updateBasicInfo: (field: string, value: any) => void;
}

export const Step1_WeddingBasics: React.FC<Step1Props> = ({ basicInfo, updateBasicInfo }) => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-6 flex items-center">
        <Users className="h-6 w-6 text-pink-500 mr-3" />
        婚禮基本資訊
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            新娘姓名 *
          </label>
          <input
            type="text"
            value={basicInfo.brideName}
            onChange={(e) => updateBasicInfo('brideName', e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent"
            placeholder="請輸入新娘姓名"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            新郎姓名 *
          </label>
          <input
            type="text"
            value={basicInfo.groomName}
            onChange={(e) => updateBasicInfo('groomName', e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent"
            placeholder="請輸入新郎姓名"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            婚禮日期 *
          </label>
          <input
            type="date"
            value={basicInfo.date}
            onChange={(e) => updateBasicInfo('date', e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            主要地點 *
          </label>
          <input
            type="text"
            value={basicInfo.venue.name}
            onChange={(e) => updateBasicInfo('venue.name', e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent"
            placeholder="例如：台北晶華酒店"
          />
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            詳細地址
          </label>
          <input
            type="text"
            value={basicInfo.venue.address}
            onChange={(e) => updateBasicInfo('venue.address', e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent"
            placeholder="請輸入完整地址"
          />
        </div>
      </div>

      <p className="text-sm text-gray-500 mt-6">
        儀式時間、交通資訊等細節，下一步可以再慢慢補，先填這幾個就好。
      </p>
    </div>
  );
};
